module.exports = DEF.TG.Details.extend({
	template: require('./poller.html')
});
